export default {
  CHECK_TYPE_SHA: 1,

  CHECK_TYPE_MD5: 0,

  REPORT: {
    READ_FILE_ERROR: 10000001,

    ENCRYPT_APPEND_ERROR: 10000002,

    REQUEST_ERROR: 10000003,

    FILE_ERROR: 10000004,

    RET_CODE_ERROR: 10000005,

    UPLOAD_FRAGMENT_BACKEND_ERROR: 10000006,

    ALL_FRAGMENT_SUCC_BUT_NOT_END: 10000007,

    PARSE_RESEPONSE_JSON_ERROR: 10000008,

    REQUEST_TIMEOUT: 10000009,

    ENCRYPT_END_ERROR: 10000010,

    ENCRYPT_WORKER_APPEND_ERROR: 10000011,

    ENCRYPT_WORKER_END_ERROR: 10000012,

    ENCRYPT_READFILE_ERROR: 10000013,

    ENCRYPT_WORKER_READFILE_ERROR: 10000014,

    ENCRYPT_WORKER_FILE_ERROR: 10000015,

    ENCRYPT_ERROR: 10000099,

    FILE_UPLOAD_TOKEN_ERROR: 10000016,

    // websocket
    CONNECT_TIMES_ERROR: 20000001,

    CONNECT_ERROR: 20000002,

    WEBSCOKET_SEND_ERROR: 20000003,

    NOT_SUPPORT_WEBSOCKET: 20000004,

    WEBSOCKET_RET_CODE_ERROR: 20000005,

    WEBSOCKET_UNKNOW_CLOSE: 20000006,

    WEBSOCKET_CLOSE_DELAY: 20000007,

    // webworker
    WEBWORKER_TIMEOUT: 30000001,

    NOT_SUPPORT_WEBWORKER: 30000002,

    POST_FILE_MESSAGE_ERROR: 30000003,
  },

  MD: {
    // encrypt
    ENCRYPT_WORKER_INIT: 104984184,

    ENCRYPT_WORKER_MESSAGE: 104984051,

    ENCRYPT_WORKER_DONE: 104979877,

    ENCRYPT_NORMAL_DONE: 104979787,

    ENCRYPT_NORMAL_DONE_64: 104984415,

    ENCRYPT_NORMAL_DONE_128: 104984416,

    ENCRYPT_NORMAL_DONE_256: 104984417,

    ENCRYPT_NORMAL_DONE_1024: 104984418,

    ENCRYPT_NORMAL_DONE_2048: 104984448,

    ENCRYPT_WASM_DONE_2048: 104987242,

    ENCRYPT_WORKER_LOADED: 104984050,

    // upload
    FILE_BATCH_CONTROL_WEBSOCKET: 104984136,

    FILE_BATCH_CONTROL_NORMAL: 104981131,

    FILE_UPLOAD_WEBSOCKET: 104984135,
    FILE_UPLOAD_WEBSOCKET_4: 104984615,
    FILE_UPLOAD_WEBSOCKET_8: 104984616,
    FILE_UPLOAD_WEBSOCKET_16: 104984617,
    FILE_UPLOAD_WEBSOCKET_20: 104984626,
    FILE_UPLOAD_WEBSOCKET_24: 104984618,
    FILE_UPLOAD_WEBSOCKET_40: 104984634,
    FILE_UPLOAD_WEBSOCKET_60: 104992808,
    FILE_UPLOAD_WEBSOCKET_80: 104992805,

    FILE_UPLOAD_FORMDATA: 104981584,

    FILE_UPLOAD_NORMAL: 104981133,

    FILE_UPLOAD_DONE_WEBSOCKET: 104984137,

    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_2_LIMIT_4: 104984593,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_2_LIMIT_8: 104984594,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_2_LIMIT_16: 104984595,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_2_LIMIT_20: 104984596,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_2_LIMIT_24: 104984597,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_2_LIMIT_40: 104984630,

    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_4: 104984598,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_8: 104984599,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_16: 104984600,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_20: 104984601,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_24: 104984602,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_40: 104984631,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_60: 104992806,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_4_LIMIT_80: 104992807,

    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_6_LIMIT_4: 104984603,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_6_LIMIT_8: 104984604,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_6_LIMIT_16: 104984605,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_6_LIMIT_20: 104984606,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_6_LIMIT_24: 104984607,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_6_LIMIT_40: 104984632,

    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_4: 104984608,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_8: 104984609,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_16: 104984610,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_20: 104984611,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_24: 104984612,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_40: 104984633,
    FILE_UPLOAD_DONE_WEBSOCKET_COUNT_8_LIMIT_80: 104992804,

    FILE_UPLOAD_DONE_FORMDATA: 104981605,

    FILE_UPLOAD_DONE_NORMAL: 104981604,

    FILE_UPLOAD_DONE_FORMDATA_4: 104984410,

    FILE_UPLOAD_DONE_FORMDATA_6: 104984414,

    FILE_UPLOAD_DONE_FORMDATA_8: 104984411,

    FILE_UPLOAD_DONE_FORMDATA_10: 104984413,

    FILE_UPLOAD_DONE_FORMDATA_20: 104984449,

    // websocket
    WEBSOCKET_OPEN: 104984133,

    WEBSOCKET_CLOSE_TIME: 104984134,

    WEBSOCKET_CLOSE_REASON: 104984168,
  },
};
